/*
Author: Shivakumar
Date: 05/12//2019
Issue Description: [salary structure] When created salary structure modified date should be DD-MMM-YYY
search_string: PL-1527
*/
<template>
  <div>
    <div>
      <div class="row-container marginb hidden">
        <div class="search-container">
          <input type="text" class="search-bar" placeholder />
          <a href="#">
            <img class="search-icon" src="@/assets/magnifying-glass.png" />
          </a>
        </div>
        <div class="spacer" />
        <div class="row-container align-center">
          <img src="@/assets/group-5.svg" class="Group-5" />
          <button
            class="text-green"
            @click="$router.push(`/onboarding/entity/${$route.params.entity_index}/preferences/addStructure`)"
          >Create New Structure</button>
        </div>
      </div>

      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <div class="permission-alert-msg" v-show="!(ifTeamleaderPermission)">
        You have only view permission.
      </div>
      <div class="empty-container" v-show="ifTeamleaderPermission">
        <div class="text">Click on ‘Add New’ to add new Salary Structure in the following list</div>
        <button v-if="componentsData.length>3" class="addnewbtn" @click="goToSalaryStructure()">
          <img src="@/assets/group-5.svg" />
          <b>Add New</b>
        </button>
      </div>
      <data-table
        :columns=" columnNames"
        :tableData="componentsData"
        :checkbox="false"
        :withForm="false"
        :showhistory="false"
        @delete="deleteItem"
        :deleteCondition="(record) => !record.default"
        @editStart="editItem"
        :disabled="!(ifTeamleaderPermission)"
      >
        <template v-slot:rowcontent="slotprops">
          <div v-if="slotprops.value.column.key=='rule' && slotprops.value.record['rule']">
            <span
              v-if="slotprops.value.record[slotprops.value.column.key].criteriaObj && slotprops.value.column.label == 'Criteria'"
            >{{slotprops.value.record[slotprops.value.column.key].criteriaObj.name}}</span>
            <span
              v-if="slotprops.value.record[slotprops.value.column.key].subCriteriaObj && slotprops.value.column.label == 'Sub-Criteria'"
            >
              <div v-if="slotprops.value.record[slotprops.value.column.key].subCriteriaObj.length">
                <div
                  v-for="(subObj,subCriteriaIndex) of slotprops.value.record[slotprops.value.column.key].subCriteriaObj"
                  :key="subCriteriaIndex"
                >
                  {{subObj.name}}
                  <span
                    v-if="subCriteriaIndex+1 != slotprops.value.record[slotprops.value.column.key].subCriteriaObj.length"
                  >,</span>
                </div>
              </div>
            </span>
          </div>
          <div v-else>
            <!-- Start PL-1527 -->
            <span
              v-if="slotprops.value.column.label != 'Modified date'"
            >{{slotprops.value.record[slotprops.value.column.key]}}</span>
            <span v-else>{{setFormatDate(slotprops.value.record[slotprops.value.column.key])}}</span>
            <!-- End PL-1527 -->
          </div>
        </template>
      </data-table>
      <div v-show="ifTeamleaderPermission">
        <form-add-button
          v-if="componentsData.length<=3"
          class="margin-t-xl"
          v-show="showAddBtn"
          main_text="+ Add New"
          sub_text="Salary Sturcture"
          @click="goToSalaryStructure()"
        ></form-add-button>
      </div>
      <pop-up-message
        v-if="showConfirmDeletePopup"
        :message="'Are you sure you want to delete ?'"
        :popupType="popupType"
        :popupHeaderMessage="'Confirm Delete'"
      >
        <template v-slot:bottomContent>
          <btn-grp>
            <popup-btn text="Cancel" type="secondary" @click="cancelEvent" />
            <popup-btn text="Delete" type="primary" @click="deleteEvent" />
          </btn-grp>
        </template>
      </pop-up-message>

      <pop-up-message
        v-if="showDefaultDeletable"
        :message="'You cannot delete this salary structure as it is a default structure !'"
        :popupType="popupType"
        :popupHeaderMessage="'Warning'"
      >
        <template v-slot:bottomContent>
          <div class="popup-btn-group">
            <button class="btn-popup-secondary" type="button" @click="cancelDefaultPopup()">Cancel</button>
          </div>
        </template>
      </pop-up-message>
    </div>
    <bottom-action-container>
      <btn-skip @navClicked="$emit('stepNum', 4)"></btn-skip>
      <template slot="end">
        <btn-grp>
          <btn text="Previous" type="secondary" @click="$emit('stepNum', 2)" />
          <btn text="Next" type="primary" @click="$emit('stepNum', 4)" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import * as constants from "@/apis/constants.js";
import { structure } from "@/assets/data/salaryStructure.js";

export default {
  name: "SalaryStructure",
  data() {
    return {
      showDefaultDeletable: false,
      structureData: structure,
      showAddBtn: true,
      columnNames: [
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Criteria",
          key: "rule"
        },
        {
          label: "Sub-Criteria",
          key: "rule"
        },
        {
          label: "Modified date",
          key: "updated_at"
        }
      ],
      toast: false,
      errmsg: "",
      currentObj: {},
      popupType: "ConfirmDelete",
      showConfirmDeletePopup: false,
      salaryStructuresData: [],
      //Start PL-1527
      fromMonthsOptions: [],
      //End PL-1527
      payrollPreferencesValue: false,
      role: ""
    };
  },
  computed: {
    ...mapState({
      salaryStructureData: state =>
        state.onboard.settings.salary_structure.entityWiseData
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else return this.getLegalEntityId(0);
    },
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    /** Function to fetch the Salary structure data list */
    componentsData() {
      if (this.salaryStructureData) {
        return this.salaryStructureData[this.leId]
          ? this.salaryStructureData[this.leId]
          : [];
      } else {
        return [];
      }
    },
    ifAnchor() {
      return localStorage.getItem("userRole") == "ANCHOR" ? true : false;
    },
    ...mapState("onboard/organization", {
      orgIds: state => state.id,
    }),
    ifTeamleaderPermission() {
      if(this.role === 'ADMIN') {
        return true;
      } else if(this.role === 'TEAMLEADER') {
        if(this.payrollPreferencesValue) {
          return true;
        } 
        else {
          return false;
        }
      } else {
        return false
      }

      // if(this.role === 'TEAMLEADER' || this.role === 'ADMIN') {
      //   if(this.payrollPreferencesValue) {
      //   return true;
      //   } else {
      //     return false;
      //   }
      // }
      // else {
      //  return true
      // }
    },
    ifSuperAdmin() {
      return localStorage.getItem("userRole") == "SUPERADMIN" ? true : false;
    },
  },
  mounted() {
    this.setConstantsData();
    this.fetchAllSalaryStructureData();
    this.getOrgLeIdList();
  },
  activated() {
    this.setConstantsData();
    this.fetchAllSalaryStructureData();
    this.getOrgLeIdList();
  },
  methods: {
    ...mapActions({
      act_fetchAll: "onboard/settings/salary_structure/fetchAll",
      act_delete: "onboard/settings/salary_structure/delete"
    }),

    ...mapActions({
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    /*** Function to Set Constants Data for drop downs ***/
    setConstantsData(){
      try {
        this.fromMonthsOptions =
          constants.monthOptionsObj.onlyMonths;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** Function to set date format */
    //Start PL-1527
    setFormatDate(event) {
      try {
        return (
          new Date(event).getDate() +
          "-" +
          this.fromMonthsOptions[new Date(event).getMonth()] +
          "-" +
          new Date(event).getFullYear()
        );
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    //End PL-1527

    /** Navigation handler */
    navHandler(navType) {
      try {
        if (navType == "back") {
          this.$emit("stepNum", 2);
          this.$validator.reset();
        }
        if (navType == "next") {
          this.$emit("stepNum", 4);
          this.$validator.reset();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Navigation to add salary structre screen */
    goToSalaryStructure() {
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/preferences/addStructure`
      });
    },
    /** Function to fetch all the slary structures data from server */
    async fetchAllSalaryStructureData() {
      try {
        let res = await this.act_fetchAll(this.leId);
        let latestSalaryStructuresData = [];
        if (res.status) {
          if (res.data.payload) {
            this.salaryStructuresData = res.data.payload;
          }
        } else {
          this.salaryStructuresData = this.componentsData();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async deleteItem(item) {
      try {
        if (item.default) {
          this.showDefaultDeletable = true;
        } else {
          this.currentObj = item;
          this.showConfirmDeletePopup = true;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    cancelDefaultPopup() {
      this.showDefaultDeletable = false;
    },
    /** On click of edit item in SS screen */
    async editItem(rec) {
      try {
        this.$router.push({
          path: `/onboarding/entity/${this.$route.params.entity_index}/preferences/modifystructure`,
          // query: { id: '2ac8b0a7-1da8-474a-b45a-a159a717ac03' }
          query: { id: rec.id }
        });
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to delete a SS */
    async deleteEvent() {
      try {
        let res = await this.act_delete([this.currentObj, this.leId]);
        if (res.status == 200) {
          this.fetchAllSalaryStructureData();
        }
        this.showConfirmDeletePopup = false;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
        this.showConfirmDeletePopup = false;
      }
    },
    cancelEvent() {
      this.showConfirmDeletePopup = false;
    },

    async getOrgLeIdList() {
      const org = this.orgIds;
      const le = this.leId;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      this.role = data.data.user.userRole;
      this.payrollPreferencesValue = data.data.user.permissions.payroll_preferences ? true : false;
      //console.log("PL-3406",data);
    }
  }
};
</script>

<style lang="scss" scoped>
.Group-5 {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.text-green {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: bold;
  color: #37c6c0;
}

.search-bar {
  width: 321px;
  border: 1px solid #d6d4d4;
  border-radius: 3px;
  height: 30px;
  padding: 5px;
  outline: none;
  position: relative;
}

.marginb {
  margin-bottom: 18px;
}

.search-icon {
  position: absolute;
  left: 295px;
  top: 6px;
  width: 18px;
  height: 18px;
}

.align-center {
  align-items: center;
}
.empty-container {
  height: 55px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .text {
    color: #858585;
    font-size: 14px;
  }
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
